import { createSlot } from "lib/@components/slot/create-slot"

// Extra summary lines under the facilities on a regime card. The card's regime is bound as parentItem.
export const RegimeItemSummary = createSlot("RegimeItemSummary")

// Screen reader text for a regime row or card, read as the focused row or card's description.
// Use it for anything a plugin shows inside the row or card, since keyboard focus never reaches it there.
export const RegimeItemDescription = createSlot("RegimeItemDescription")
